import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure65 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        height: 1000,
        type: 'bar',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#71ad47', '#92d04f', '#385723',],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [
	     "Monde",
	     "",
	     "Asie centrale <br /> et du Sud",
	     "Asie de l’Est <br /> et du Sud-Est",
	     "Afrique du Nord <br/> et Asie de l’Ouest",
	     "Afrique <br/> subsaharienne",
	     "Europe et <br/> Amérique du Nord",
	     "Amérique latine <br/> et Caraïbes",
	     "Océanie",
	     "",
	     "Pays en développement <br/> sans littoral (PDSL)",
	     "Pays les moins <br/> avancés (PMA)",
	     "Petits États <br/> insulaires en développement (PEID)",
        ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
  
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{ // Primary yAxis
        labels: {
          format: '{value} ',
          	format: '{value}',
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 80,
        min: 0,
        tickInterval: 10,
        gridLineWidth:2,
        title: {
          text: 'Pourcentage',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: '2000',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '10px'
          }
  
        },
        data: [31.9,
          null,
        10.4,
      28.4,
    4.6,
  30.8,
40.7,
50.8,
21.6,
null,
18.0,
29.7,
73.0,]
      },{
        name: '2010',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '10px'
          }
  
        },
        data: [31.5,
          null,
        10.7,
      29.5,
    4.6,
  29.3,
41.1,
48.1,
21.3,
null,
17.4,
28.2,
73.4,]
      },{
        name: '2020',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '10px'
          }
  
        },
        data: [31.2,
          null,
        11.0,
      30.0,
    4.6,
  27.6,
41.2,
46.7,
21.8,
null,
16.6,
26.3,
73.3,]
      },
    ]

}